<div
  class="w-full max-w-sm rounded-xl border px-4 py-3 shadow-theme-xs backdrop-blur"
  [ngClass]="variantClasses"
>
  <div class="flex items-start justify-between gap-3">
    <div class="min-w-0">
      @if (item.title) {
        <h4 class="text-sm font-semibold" [ngClass]="titleClasses">
          {{ item.title }}
        </h4>
      }
      <p class="mt-0.5 text-sm text-gray-700 dark:text-white/80">
        {{ item.message }}
      </p>
    </div>

    @if (item.closable !== false) {
      <button
        type="button"
        class="shrink-0 rounded-lg p-1 text-gray-500 hover:bg-black/5 hover:text-gray-700 dark:hover:bg-white/10 dark:text-white/60 dark:hover:text-white"
        (click)="onClose()"
        aria-label="Cerrar"
      >
        ✕
      </button>
    }
  </div>
</div>
